import React from "react";
import "./Services.css";
import { BsDribbble } from "react-icons/bs";
import { AiFillFileText } from "react-icons/ai";
import {BiLogoReact,BiLogoNodejs,BiCodeAlt } from "react-icons/bi";

export default function Services() {
  return (
    <section id="services" className="services section-bg">
      <div className="container" data-aos="fade-up">
        <div className="section-title">
          <h2>Services</h2>
          <p className="service-para">Your commitment fuels our dedication together, we deliver on promises, ensuring trust, transparency, and timely results for your success.</p>
        </div>

        <div className="row">
          <div
            className="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12 service-box"
            data-aos="zoom-in"
            data-aos-delay="100"
          >
            <div className="icon-box">
              <div className="review1">
                <div className="icon">
                  <BsDribbble />
                </div>
                <h4>UI/UX Design</h4>
              </div>
              <div className="review2">
                <p>
                  At our UI/UX Design agency, we're dedicated to enhancing the
                  way users interact with digital products. Our team of creative
                  and skilled designers specializes in crafting visually
                  appealing, intuitive interfaces that prioritize user
                  experience. We understand that a well-designed user interface
                  not only captures attention but also ensures seamless
                  navigation and engagement.
                </p>
              </div>
            </div>
          </div>

          <div
            className="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12 service-box"
            data-aos="zoom-in"
            data-aos-delay="200"
          >
            <div className="icon-box icon-box1">
              <div className="review">
                <div className="icon">
                  <BiCodeAlt />
                </div>
                <h4>Web Development</h4>
              </div>
              <div className="review">
                <p>
                  Our web developer services are your gateway to a powerful
                  online presence. We specialize in creating dynamic,
                  high-performance websites and web applications that meet your
                  unique goals and requirements. Whether you need a sleek and
                  responsive website, a robust e-commerce platform, or a custom
                  web solution, our team of experienced developers has the
                  expertise to bring your vision to life.
                </p>
              </div>
            </div>
          </div>

          <div
            className="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12 service-box mt-4"
            data-aos="zoom-in"
            data-aos-delay="300"
          >
            <div className="icon-box">
              <div className="review">
                <div className="icon">
                  <BiLogoReact />
                </div>
                <h4>React Js Development</h4>
              </div>
              <div className="review">
                <p>
                  Our React.js developer services offer a cutting-edge solution
                  for building dynamic and responsive web applications. With a
                  focus on speed, flexibility, and exceptional user interfaces,
                  our team of skilled React.js developers is well-equipped to
                  bring your digital projects to life. our React.js development
                  services are tailored to meet your specific needs, driving
                  innovation and efficiency in your web-based ventures.
                </p>
              </div>
            </div>
          </div>

          <div
            className="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12 service-box mt-4"
            data-aos="zoom-in"
            data-aos-delay="400"
          >
            <div className="icon-box">
              <div className="review">
                <div className="icon">
                  <BiLogoNodejs />
                </div>
                <h4>Backend Development</h4>
              </div>
              <div className="review">
                <p>
                  Our backend development services powered by Node.js offer a
                  robust foundation for your web applications and services. Our
                  team of skilled Node.js developers is dedicated to building
                  high-performance, scalable, and efficient backend systems that
                  drive the functionality of your digital products.
                </p>
              </div>
            </div>
          </div>
          <div
            className="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12 service-box mt-4"
            data-aos="zoom-in"
            data-aos-delay="400"
          >
            <div className="icon-box">
              <div className="review">
                <div className="icon">
                  <AiFillFileText />
                </div>
                <h4>Data Scrapping</h4>
              </div>
              <div className="review">
                <p>
                  Our expert data scraping team utilizes cutting-edge technology
                  and techniques to collect, clean, and organize data from
                  websites, social media, e-commerce platforms, and more.
                  Whether you need market research, competitive analysis, or
                  data-driven decision support, our services are tailored to
                  suit your specific requirements. We prioritize data accuracy,
                  compliance with legal and ethical standards, and timely
                  delivery, ensuring that the information we provide empowers
                  your business with a competitive edge.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
